'use strict';

angular.module('msAssessment').directive('keypressEvents', ['$document', function ($document) {
  return {
    restrict: 'A',
    scope: {
      keypressAction: '&ngClick'
    },
    link: function link(scope, element, attrs) {
      /**
       * This is a global declaration of an event that will always evaluate to true for the given keypress.
       * Ideally, this event would be registered on the $rootScope and emit a custom event that can be captured
       * by any controller.  Than a decision gate can be coded to allow/disallow the execution of the keypressAction.
       */
      $document.bind('keyup', function (e) {
        if (String.fromCharCode(e.which) === attrs.keypressTarget) {
          scope.$eval(scope.keypressAction);
        }
      });

      /**
       * This is a bandaid to allow the scope to destroy the global binding of this event when the html fragment is
       * removed from page scope.
       */
      scope.$on('$destroy', function () {
        $document.unbind('keyup');
      });
    }
  };
}]);